// @flow

import { useTranslator } from '@gandi/translate';

import {
  TextField,
  type Props as FieldProps,
} from 'src/Reshaped/Form/TextField';

import { useFlagPrefix } from '../hooks/useFlagPrefix';

type Props = {
  ...Partial<FieldProps>,
  name: string,
  placeholder?: string,
};

export function Phone({
  label,
  name,
  help,
  placeholder,
  rules,
  disabled,
  control,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const prefix = useFlagPrefix();

  return (
    <TextField
      name={name}
      label={label}
      prefix={prefix}
      disabled={disabled}
      inputAttributes={{ type: 'tel' }}
      inputProps={{ placeholder }}
      control={control}
      rules={{
        ...rules,
        pattern: {
          value: /^[+(\s.\-/\d)]{5,30}$/,
          message: __('This is not a valid phone number'),
        },
      }}
      help={help}
    />
  );
}
